import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    eventoId: 0,
    evento: '',
    
    eventoSolicitaCodigoPromocion: false,
    eventoRequiereCodigoPromocion: false,
    eventoSolicitaNombre: false,
    eventoRequiereNombre: false,
    eventoSolicitaDocumento: false,
    eventoRequiereDocumento: false,
    eventoSolicitaDatosPersonales: false,
    eventoSolicitaTelefono: false,
    eventoRequiereTelefono: false,
    eventoSolicitaEmail: false,
    eventoRequiereEmail: false,
    eventoSolicitaUbicacion: false,
    eventoRequiereUbicacion: false,
    eventoSolicitaLocalidad: false,
    eventoRequiereLocalidad: false,
    eventoSolicitaBarrio: false,
    eventoRequiereBarrio: false,
    eventoRequiereInformacionBancaria: false,
    eventoParticipacionNegocios: false,
    eventoSolicitaPosicionNegocio: false,
    eventoRequierePosicionNegocio: false,
    eventoSolicitaRazonSocialNegocio: false,
    eventoRequiereRazonSocialNegocio: false,
    eventoSolicitaDocumentoNegocio: false,
    eventoRequiereDocumentoNegocio: false,
    eventoSolicitaUbicacionNegocio: false,
    eventoRequiereUbicacionNegocio: false,
    eventoSolicitaLocalidadNegocio: false,
    eventoRequiereLocalidadNegocio: false,
    eventoSolicitaBarrioNegocio: false,
    eventoRequiereBarrioNegocio: false,
    eventoValidaNumeroCliente: false,
    eventoImportaGanadores: false,

    eventoCamposAdicionales: [],

    eventoEtapaId: 0,
    eventoEtapa: null,
    eventoEtapaNombre: null,
    eventoEtapas: null,
    eventoEtapasList: [],

    codigoPromocion: '',

    id: 0,
    documentoNumero: '',
    apellido: '',
    nombre: '',
    fechaNacimiento: '1900-01-01',
    fechaNacimientoHabilitada: false,
    sexo: '',

    prefijo: '',
    celular: '',
    email: '',
    
    paisId: 0,
    pais: null,
    paisNombre: null,
    provinciaId: 0,
    provincia: null,
    provinciaNombre: null,
    localidadId: 0,
    localidad: null,
    localidadNombre: null,
    barrio: '',
    direccionCalle: '',
    direccionNumero: 0,
    codigoPostal: '',

    bancoId: 0,
    banco: null,
    bancoNombre: null,
    cbu: '',
    cbuAlias: '',
    titularCuenta: '',
    titularCuit: '',

    /* Datos del negocio */
    posicion: '',
    nombreComercial: '',
    razonSocial: '',
    cuit: '',
    negocioPaisId: 0,
    negocioPais: null,
    negocioPaisNombre: null,
    negocioProvinciaId: 0,
    negocioProvincia: null,
    negocioProvinciaNombre: null,
    negocioLocalidadId: 0,
    negocioLocalidad: null,
    negocioLocalidadNombre: null,
    negocioBarrio: '',
    negocioDireccionCalle: '',
    negocioDireccionNumero: 0,
    negocioCodigoPostal: '',

    participanteId: 0,
    posicionSorteo: 0,

    clientePrevio: false,
    numeroCliente: '',
    observaciones: '',

    rowVersion: null,

    camposAdicionales: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_PARTICIPANTE' (state, params) {
        state.eventoId = params.eventoId;
        state.evento = '';
        // state.eventoWhapp = false;
        state.eventoSolicitaCodigoPromocion = false;
        state.eventoRequiereCodigoPromocion = false;
        state.eventoSolicitaNombre = false;
        state.eventoRequiereNombre = false;
        state.eventoSolicitaDocumento = false;
        state.eventoRequiereDocumento = false;
        state.eventoSolicitaDatosPersonales = false;
        state.eventoSolicitaTelefono = false;
        state.eventoRequiereTelefono = false;
        state.eventoSolicitaEmail = false;
        state.eventoRequiereEmail = false;
        state.eventoSolicitaUbicacion = false;
        state.eventoRequiereUbicacion = false;
        state.eventoSolicitaLocalidad = false;
        state.eventoRequiereLocalidad = false;
        state.eventoSolicitaBarrio = false;
        state.eventoRequiereBarrio = false;
        state.eventoRequiereInformacionBancaria = false;
        state.eventoParticipacionNegocios = false;
        state.eventoSolicitaPosicionNegocio = false;
        state.eventoRequierePosicionNegocio = false;
        state.eventoSolicitaRazonSocialNegocio = false;
        state.eventoRequiereRazonSocialNegocio = false;
        state.eventoSolicitaDocumentoNegocio = false;
        state.eventoRequiereDocumentoNegocio = false;
        state.eventoSolicitaUbicacionNegocio = false;
        state.eventoRequiereUbicacionNegocio = false;
        state.eventoSolicitaLocalidadNegocio = false;
        state.eventoRequiereLocalidadNegocio = false;
        state.eventoSolicitaBarrioNegocio = false;
        state.eventoRequiereBarrioNegocio = false;
        state.eventoValidaNumeroCliente = false;
        state.eventoImportaGanadores = false;
        state.eventoCamposAdicionales = [];

        state.eventoEtapaId = 0;
        state.eventoEtapa = null;
        state.eventoEtapaNombre = null;
        state.eventoEtapas = null;
        state.eventoEtapasList = [];

        state.id = params.participanteId;
        state.documentoNumero = '';
        state.apellido = '';
        state.nombre = '';
        state.fechaNacimiento = '1900-01-01';
        state.fechaNacimientoHabilitada = false;
        state.sexo = '';

        state.prefijo = '';
        state.celular = '';
        state.email = '';
        
        state.paisId = 0;
        state.pais = null;
        state.paisNombre = null;
        state.provinciaId = 0;
        state.provincia = null;
        state.provinciaNombre = null;
        state.localidadId = 0;
        state.localidad = null;
        state.localidadNombre = null;
        state.barrio = '';
        state.direccionCalle = '';
        state.direccionNumero = 0;
        state.codigoPostal = '';
    
        state.bancoId = 0;
        state.banco = null;
        state.bancoNombre = null;
        state.cbu = '';
        state.cbuAlias = '';
        state.titularCuenta = '';
        state.titularCuit = '';
    
        /* Datos del negocio */
        state.posicion = '';
        state.nombreComercial = '';
        state.razonSocial = '';
        state.cuit = '';
        state.negocioPaisId = 0;
        state.negocioPais = null;
        state.negocioPaisNombre = null;
        state.negocioProvinciaId = 0;
        state.negocioProvincia = null;
        state.negocioProvinciaNombre = null;
        state.negocioLocalidadId = 0;
        state.negocioLocalidad = null;
        state.negocioLocalidadNombre = null;
        state.negocioBarrio = '';
        state.negocioDireccionCalle = '';
        state.negocioDireccionNumero = 0;
        state.negocioCodigoPostal = '';
    
        state.codigoPromocion = '';

        /* Referencia para reinscripciones */
        state.participanteId = 0;
        /* Importacion de ganadores*/
        state.posicionSorteo = 0;

        state.clientePrevio = false;
        state.numeroCliente = '';

        state.observaciones = '';
        state.rowVersion = null;

        state.camposAdicionales = [];
    },
    'SET_EVENTO' (state, evento) {
        state.evento = evento.nombre.trim(),
        state.eventoSolicitaCodigoPromocion = (/true/i).test(evento.solicitaCodigoPromocion);
        state.eventoRequiereCodigoPromocion = (/true/i).test(evento.requiereCodigoPromocion);
        state.eventoSolicitaNombre = (/true/i).test(evento.solicitaNombre);
        state.eventoRequiereNombre = (/true/i).test(evento.requiereNombre);
        state.eventoSolicitaDocumento = (/true/i).test(evento.solicitaDocumento);
        state.eventoRequiereDocumento = (/true/i).test(evento.requiereDocumento);
        state.eventoSolicitaDatosPersonales = (/true/i).test(evento.solicitaDatosPersonales);
        state.eventoSolicitaTelefono = (/true/i).test(evento.solicitaTelefono);
        state.eventoRequiereTelefono = (/true/i).test(evento.requiereTelefono);
        state.eventoSolicitaEmail = (/true/i).test(evento.solicitaEmail);
        state.eventoRequiereEmail = (/true/i).test(evento.requiereEmail);
        state.eventoSolicitaUbicacion = (/true/i).test(evento.solicitaUbicacion);
        state.eventoRequiereUbicacion = (/true/i).test(evento.requiereUbicacion);
        state.eventoSolicitaLocalidad = (/true/i).test(evento.solicitaLocalidad);
        state.eventoRequiereLocalidad = (/true/i).test(evento.requiereLocalidad);
        state.eventoSolicitaBarrio = (/true/i).test(evento.solicitaBarrio);
        state.eventoRequiereBarrio = (/true/i).test(evento.requiereBarrio);
        state.eventoRequiereInformacionBancaria = (/true/i).test(evento.requiereInformacionBancaria);
        state.eventoParticipacionNegocios = (/true/i).test(evento.participacionNegocios);
        state.eventoSolicitaPosicionNegocio = (/true/i).test(evento.solicitaPosicionNegocio);
        state.eventoRequierePosicionNegocio = (/true/i).test(evento.requierePosicionNegocio);
        state.eventoSolicitaRazonSocialNegocio = (/true/i).test(evento.solicitaRazonSocialNegocio);
        state.eventoRequiereRazonSocialNegocio = (/true/i).test(evento.requiereRazonSocialNegocio);
        state.eventoSolicitaDocumentoNegocio = (/true/i).test(evento.solicitaDocumentoNegocio);
        state.eventoRequiereDocumentoNegocio = (/true/i).test(evento.requiereDocumentoNegocio);
        state.eventoSolicitaUbicacionNegocio = (/true/i).test(evento.solicitaUbicacionNegocio);
        state.eventoRequiereUbicacionNegocio = (/true/i).test(evento.requiereUbicacionNegocio);
        state.eventoSolicitaLocalidadNegocio = (/true/i).test(evento.solicitaLocalidadNegocio);
        state.eventoRequiereLocalidadNegocio = (/true/i).test(evento.requiereLocalidadNegocio);
        state.eventoSolicitaBarrioNegocio = (/true/i).test(evento.solicitaBarrioNegocio);
        state.eventoRequiereBarrioNegocio = (/true/i).test(evento.requiereBarrioNegocio);
        state.eventoImportaGanadores = (/true/i).test(evento.importaGanadores);
        state.eventoValidaNumeroCliente = false;

        if (evento.etapas) {
            if (evento.etapas.length != 0) {
                state.eventoEtapas = evento.etapas;
                state.eventoEtapasList = evento.etapas.map(etapa => etapa.nombre.trim());
            }
        }
        
        /* Campos adicionales del participante */
        state.eventoCamposAdicionales = evento.camposAdicionales;

        state.camposAdicionales = state.eventoCamposAdicionales.map(campoAdicional => ({
            id: campoAdicional.id,
            campo: campoAdicional.campo,
            valor: '',
            obligatorio: (/true/i).test(campoAdicional.obligatorio)
        }))
    },
    'SET_PARTICIPANTE' (state, participante) {
        state.documentoNumero = participante.documentoNumero? participante.documentoNumero.trim() : '';
        state.apellido = participante.apellido.trim();
        state.nombre = participante.nombre.trim();
        state.fechaNacimiento = moment(participante.fechaNacimiento).format('YYYY-MM-DD');
        if (moment(state.fechaNacimiento).format('YYYY-MM-DD') != '1900-01-01') {
            state.fechaNacimientoHabilitada = true;
        } else {
            state.fechaNacimientoHabilitada = false;   
        }
        state.sexo = participante.sexo.trim();

        state.prefijo = participante.prefijo.trim();
        state.celular = participante.celular.trim();
        state.email = participante.email.trim();
        
        state.paisId = participante.paisId;
        if (participante.paisId != 0) {
            state.pais = {
                id: participante.paisId,
                nombre: participante.pais
            }
            state.paisNombre = participante.pais;
        } else {
            state.pais = null;
            state.paisNombre = null;
        }
        state.provinciaId = participante.provinciaId;
        if (participante.provinciaId != 0) {
            state.provincia = {
                id: participante.provinciaId,
                nombre: participante.provincia
            }
            state.provinciaNombre = participante.provincia;
        } else {
            state.provincia = null;
            state.provinciaNombre = null;
        }
        state.localidadId = participante.localidadId;
        if (participante.localidadId != 0) {
            state.localidad = {
                id: participante.localidadId,
                nombre: participante.localidad
            }
            state.localidadNombre = participante.localidad;
        } else {
            state.localidad = null;
            state.localidadNombre = null;
        }
        state.barrio = participante.barrio.trim();
        state.direccionCalle = participante.direccionCalle.trim();
        state.direccionNumero = participante.direccionNumero;
        state.codigoPostal = participante.codigoPostal.trim();
    
        state.bancoId = participante.bancoId;
        if (participante.bancoId != 0) {
            state.banco = {
                id: participante.bancoId,
                nombre: participante.banco
            }
            state.bancoNombre = participante.banco;
        } else {
            state.banco = null;
            state.bancoNombre = null;
        }
        state.cbu = participante.cbu.trim();
        state.cbuAlias = participante.cbuAlias.trim();
        state.titularCuenta = participante.titularCuenta.trim();
        state.titularCuit = participante.titularCuit.trim();
    
        /* Datos del negocio */
        state.posicion = participante.posicion? participante.posicion.trim() : '';
        state.nombreComercial = participante.nombreComercial.trim();
        state.razonSocial = participante.razonSocial.trim();
        state.cuit = participante.cuit.trim();
        state.negocioPaisId = participante.negocioPaisId;
        if (participante.negocioPaisId != 0) {
            state.negocioPais = {
                id: participante.negocioPaisId,
                nombre: participante.negocioPais
            };
            state.negocioPaisNombre = participante.negocioPais;
        } else {
            state.negocioPais = null;
            state.negocioPaisNombre = null;
        }
        state.negocioProvinciaId = participante.negocioProvinciaId;
        if (participante.negocioProvinciaId != 0) {
            state.negocioProvincia = {
                id: participante.negocioProvinciaId,
                nombre: participante.negocioProvincia
            };
            state.negocioProvinciaNombre = participante.negocioProvincia;
        } else {
            state.negocioProvincia = null;
            state.negocioProvinciaNombre = null;
        }
        state.negocioLocalidadId = participante.negocioLocalidadId;
        if (participante.negocioLocalidadId != 0) {
            state.negocioLocalidad = {
                id: participante.negocioLocalidadId,
                nombre: participante.negocioLocalidad
            };
            state.negocioLocalidadNombre = participante.negocioLocalidad;
        } else {
            state.negocioLocalidad = null;
            state.negocioLocalidadNombre = null;
        }
        state.negocioBarrio = participante.negocioBarrio.trim();
        state.negocioDireccionCalle = participante.negocioDireccionCalle.trim();
        state.negocioDireccionNumero = participante.negocioDireccionNumero;
        state.negocioCodigoPostal = participante.negocioCodigoPostal.trim();
        
        state.codigoPromocion = participante.codigoPromocion.trim();

        state.clientePrevio = (/true/i).test(participante.clientePrevio);
        state.numeroCliente = participante.numeroCliente.trim();

        /* Referencia para reinscripciones */
        state.participanteId = participante.participanteId;

        /* Importacion de ganadores*/
        state.posicionSorteo = participante.posicionSorteo;

        state.observaciones = participante.observaciones.trim();
        state.rowVersion = participante.rowVersion;

        if (participante.camposAdicionales) {
            state.camposAdicionales.forEach(campoAdicional => {
                let participanteCampo = participante.camposAdicionales.find(t => t.eventoCampoAdicionalId == campoAdicional.id);
                if (participanteCampo) {
                    campoAdicional.valor = participanteCampo.valor.trim()
                }
            });
        }

        // state.camposAdicionales = [];
    },
    'SET_EVENTO_ETAPA'(state, eventoEtapa) {
        state.eventoEtapa = eventoEtapa;
        if (eventoEtapa) {
            state.eventoEtapaId = eventoEtapa.id? eventoEtapa.id : 0;
            state.eventoEtapaNombre = eventoEtapa.nombre? eventoEtapa.nombre.trim() : null;
        } else {
            state.eventoEtapaId = 0;
            state.eventoEtapaNombre = null;
        }
        // console.log(state.eventoEtapaId);
    },
    'SET_PAIS'(state, pais) {
        state.pais = pais;
        if (pais) {
            state.paisId = pais.id? pais.id : 0;
            state.paisNombre = pais.nombre? pais.nombre.trim() : null;
        } else {
            state.paisId = 0;
            state.paisNombre = null;
        }
    },
    'SET_PROVINCIA'(state, provincia) {
        state.provincia = provincia;
        if (provincia) {
            state.provinciaId = provincia.id? provincia.id : 0;
            state.provinciaNombre = provincia.nombre? provincia.nombre.trim() : null;
        } else {
            state.provinciaId = 0;
            state.provinciaNombre = null;
        }
    },
    'SET_LOCALIDAD'(state, localidad) {
        state.localidad = localidad;
        if (localidad) {
            state.localidadId = localidad.id? localidad.id : 0;
            state.localidadNombre = localidad.nombre? localidad.nombre.trim() : null;
        } else {
            state.localidadId = 0;
            state.localidadNombre = null;
        }
    },
    'SET_BANCO'(state, banco) {
        state.banco = banco;
        if (banco) {
            state.bancoId = banco.id? banco.id : 0;
            state.bancoNombre = banco.nombre? banco.nombre.trim() : null;
        } else {
            state.bancoId = 0;
            state.bancoNombre = null;
        }
    },
    'SET_NEGOCIO_PAIS'(state, pais) {
        state.negocioPais = pais;
        if (pais) {
            state.negocioPaisId = pais.id? pais.id : 0;
            state.negocioPaisNombre = pais.nombre? pais.nombre.trim() : null;
        } else {
            state.negocioPaisId = 0;
            state.negocioPaisNombre = null;
        }
    },
    'SET_NEGOCIO_PROVINCIA'(state, provincia) {
        state.negocioProvincia = provincia;
        if (provincia) {
            state.negocioProvinciaId = provincia.id? provincia.id : 0;
            state.negocioProvinciaNombre = provincia.nombre? provincia.nombre.trim() : null;
        } else {
            state.negocioProvinciaId = 0;
            state.negocioProvinciaNombre = null;
        }
    },
    'SET_NEGOCIO_LOCALIDAD'(state, localidad) {
        state.negocioLocalidad = localidad;
        if (localidad) {
            state.negocioLocalidadId = localidad.id? localidad.id : 0;
            state.negocioLocalidadNombre = localidad.nombre? localidad.nombre.trim() : null;
        } else {
            state.negocioLocalidadId = 0;
            state.negocioLocalidadNombre = null;
        }
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PARTICIPANTE', params);

            let getParticipante = false;
            if (params) {
                if (params.participanteId) {
                    if (params.participanteId != 0) {
                        getParticipante = true;
                    }
                }
            }

            if (getParticipante) {
                /* Recuperamos los datos del evento */
                apiAxios.get('eventos/' + params.eventoId) 
                    .then(res => {
                        commit('SET_EVENTO', res.data);
                        /* Recuperamos los datos del participante */
                        return apiAxios.get('eventos/' + params.eventoId + '/participante/' + params.participanteId + '/abm');
                    })
                    .then(res => {
                        commit('SET_PARTICIPANTE', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));

            } else {
                /* Recuperamos los datos del evento */
                apiAxios.get('eventos/' + params.eventoId) 
                    .then(res => {
                        commit('SET_EVENTO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let save = true;
            let errorMessage = '';

            if (state.camposAdicionales) {
                state.camposAdicionales.forEach(campoAdicional => {
                    if ((/true/i).test(campoAdicional.obligatorio)) {
                        if (campoAdicional.valor.trim() == '') {
                            save = false;
                            errorMessage = `Debe ingresar el valor del campo ${campoAdicional.campo}`;
                        }
                    }
                });
            }

            if (save) {
                let fechaNacimiento = '1900-01-01';
                if ((/true/i).test(state.fechaNacimientoHabilitada)) {
                    fechaNacimiento = moment(state.fechaNacimiento).format('YYYY-MM-DD');
                }

                let numeroCliente = '';
                if ((/true/i).test(state.clientePrevio)) {
                    numeroCliente = state.numeroCliente.trim();
                }

                let camposAdicionales = [];
                if (state.camposAdicionales) {
                    camposAdicionales = state.camposAdicionales.map(campoAdicional => ({
                        eventoCampoAdicionalId: campoAdicional.id,
                        campo: campoAdicional.campo.toUpperCase().trim(),
                        valor: campoAdicional.valor.toUpperCase().trim()
                    }))
                }
    
                let participante= {
                    codigoPromocion: state.codigoPromocion.trim(),
                    
                    documentoNumero: state.documentoNumero,
                    apellido: state.apellido.toUpperCase().trim(),
                    nombre: state.nombre.toUpperCase().trim(),
                    fechaNacimiento: fechaNacimiento,
                    sexo: state.sexo.toUpperCase().trim(),
                    prefijo: state.prefijo.trim(),
                    celular: state.celular.trim(),
                    email: state.email.toLowerCase().trim(),

                    paisId: parseInt(state.paisId),
                    provinciaId: parseInt(state.provinciaId),
                    localidadId: parseInt(state.localidadId),
                    barrio: state.barrio.toUpperCase().trim(),
                    direccionCalle: state.direccionCalle.toUpperCase().trim(),
                    direccionNumero: parseInt(state.direccionNumero),
                    codigoPostal: state.codigoPostal.trim(),

                    bancoId: parseInt(state.bancoId),
                    cbu: state.cbu.trim(),
                    cbuAlias: state.cbuAlias.toUpperCase().trim(),
                    titularCuenta: state.titularCuenta.toUpperCase().trim(),
                    titularCuit: state.titularCuit.trim(),
                
                    /* Datos del negocio */
                    posicion: state.posicion.toUpperCase().trim(),
                    nombreComercial: state.nombreComercial.toUpperCase().trim(),
                    razonSocial: state.razonSocial.toUpperCase().trim(),
                    cuit: state.cuit.trim(),
                    negocioPaisId: parseInt(state.negocioPaisId),
                    negocioProvinciaId: parseInt(state.negocioProvinciaId),
                    negocioLocalidadId: parseInt(state.negocioLocalidadId),
                    negocioBarrio: state.negocioBarrio.toUpperCase().trim(),
                    negocioDireccionCalle: state.negocioDireccionCalle.toUpperCase().trim(),
                    negocioDireccionNumero: parseInt(state.negocioDireccionNumero),
                    negocioCodigoPostal: state.negocioCodigoPostal.trim(),
                
                    codigoPromocion: state.codigoPromocion.trim(),
                    
                    /* Referencia para reinscripciones */
                    participanteId: state.participanteId,
                    /* Importacion de ganadores*/
                    posicionSorteo: state.posicionSorteo,

                    clientePrevio: (/true/i).test(state.clientePrevio),
                    numeroCliente: numeroCliente,
                    
                    observaciones: state.observaciones.trim(),

                    camposAdicionales
                };

                let url = 'eventos/' + state.eventoId + '/participante';

                if (state.eventoEtapaId != 0) {
                    url = 'eventos/' + state.eventoId + '/etapa/' + state.eventoEtapaId + '/participante';
                }

                if (state.id) {
                    if (state.id != 0) {
                        url += '/' + state.id;
                        participante.rowVersion = state.rowVersion;
                    }
                }

                apiAxios.post(url, participante)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                reject(errorMessage);
            }
        })
    },
    setEventoEtapa: ({ commit }, eventoEtapa) => {
        commit('SET_EVENTO_ETAPA', eventoEtapa);
    },
    setPais: ({ commit }, pais) => {
        commit('SET_PAIS', pais);
    },
    setProvincia: ({ commit }, provincia) => {
        commit('SET_PROVINCIA', provincia);
    },
    setLocalidad: ({ commit }, localidad) => {
        commit('SET_LOCALIDAD', localidad);
    },
    setBanco: ({ commit }, banco) => {
        commit('SET_BANCO', banco);
    },
    setNegocioPais: ({ commit }, pais) => {
        commit('SET_NEGOCIO_PAIS', pais);
    },
    setNegocioProvincia: ({ commit }, provincia) => {
        commit('SET_NEGOCIO_PROVINCIA', provincia);
    },
    setNegocioLocalidad: ({ commit }, localidad) => {
        commit('SET_NEGOCIO_LOCALIDAD', localidad);
    },
    validarCodigoPromocion ({ state }) {
        return new Promise((resolve, reject) => {
            if (state.codigoPromocion.trim() == '') {
                reject('Debe ingresar el código de promoción a validar');
            } else {
                let url = 'eventos/' + state.eventoId + '/validar-codigo/' + state.codigoPromocion.trim();
                
                if (state.id) {
                    if (state.id != 0) {
                        url = 'eventos/' + state.eventoId + '/participante/' + state.id +  '/validar-codigo/' + state.codigoPromocion.trim();
                    }
                }

                apiAxios.get(url)
                    .then(() => resolve())
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}